<div
  class="thread-wrapper"
  [class.selected]="selected"
  [class.private]="thread.private"
  [class.resolved]="thread.resolved"
>
  <div
    class="thread"
    [class.hover]="hover"
    (mouseover)="threadHover.emit(thread)"
    (mouseout)="threadHover.emit(undefined)"
  >
    <app-comment-item
      [class.private]="thread.private"
      [comment]="thread"
      [accessLevel]="accessLevel"
      [myId]="me?.id"
      [asset]="asset"
      [replies]="replies()"
      [expandReplies]="expandReplies"
      (deleteComment)="deleteComment.emit($event)"
      (resolveThread)="resolveThread.emit($event)"
      (updateComment)="updateComment(thread, $event)"
      (unselect)="unselect.emit()"
      (click)="toggleSelectedThread.emit()"
    ></app-comment-item>

    @if (expandReplies) {
      @for (reply of replies(); track reply.id) {
        <div class="thread-part" [@threadReply]>
          <app-comment-item
            [class.private]="reply.private"
            [comment]="reply"
            [accessLevel]="accessLevel"
            [myId]="me?.id"
            [asset]="asset"
            (deleteComment)="deleteComment.emit($event)"
            (updateComment)="updateComment(reply, $event)"
          ></app-comment-item>
        </div>
      }
    }

    @if (expandReplies || !replies().length) {
      @if (!thread.resolved) {
        <div class="thread-part" [@replyBox] (click)="selectThread.emit()">
          <div
            class="reply-box"
            [class.private]="thread.private || privateReply()"
            (click)="focusMessage()"
            appClickOutside
            (onClickOutside)="unfocusMessage()"
          >
            <div class="input-container">
              <app-avatar [user]="me"></app-avatar>
              <div class="textarea-container" (click)="messageClick($event)">
                @if (!replyText) {
                  <div class="placeholder">Add a reply...</div>
                }
                <div
                  #commentField
                  class="textarea"
                  name="reply"
                  contenteditable
                  [(wysiwyg)]="replyText"
                  [allowHtml]="true"
                  (click)="focusMessage()"
                ></div>
              </div>
            </div>

            @if (messageFocused() || replyText.length || emojiMenuIsOpen()) {
              <div class="reply-actions" [@replyActions]>
                <div class="spacer"></div>

                @if (accessLevel === 'edit' && isTeamMember && !thread.private && growthBook.isOn('private-comments')) {
                  <button
                    appButton
                    name="toggle-private"
                    location="create-comment-overlay"
                    appTooltip="Team only"
                    [iconButton]="true"
                    [color]="privateReply() ? 'simple-orange' : 'simple'"
                    shape="round"
                    height="-1"
                    (click)="togglePrivateClick($event)"
                  >
                    @if (privateReply()) {
                      <app-svg src="/assets/icons/lock.svg"></app-svg>
                    } @else {
                      <app-svg src="/assets/icons/lock-off.svg"></app-svg>
                    }
                  </button>
                }

                <app-context-menu
                  [options]="{ width: '360px', noSpacing: true }"
                  class="emoji-toggle"
                  #emojiMenu
                  (onToggle)="emojiMenuIsOpen.set($event)"
                >
                  <button
                    appButton
                    name="add-emoji"
                    location="comment-thread"
                    [iconButton]="true"
                    color="simple"
                    height="0"
                    appTooltip="Add emojis"
                    contextButton
                    shape="round"
                  >
                    <app-svg src="/assets/icons/24/smiley-outline.svg" size="0"></app-svg>
                  </button>
                  <div contextContent>
                    @defer (when emojiMenu.isOpen) {
                      <app-emoji-selector (onSelect)="addEmoji($event)"></app-emoji-selector>
                    } @error {}
                  </div>
                </app-context-menu>

                <button
                  class="send-button"
                  appButton
                  name="send"
                  location="comment-thread"
                  data-test-id="send-reply-button"
                  color="primary"
                  height="1"
                  shape="round"
                  (click)="sendReply()"
                >
                  Send
                </button>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
